class SessionStore {

    readToken() {
        return localStorage.getItem('authToken');
    }

    storeToken(token) {
        return localStorage.setItem('authToken', token);
    }

    readUser() {
        return JSON.parse(localStorage.getItem('authUser'));
    }

    storeUser(user) {
        return localStorage.setItem('authUser', JSON.stringify(user));
    }

    clear() {
        localStorage.removeItem('authUser');
        localStorage.removeItem('authToken');
    }
}

export default SessionStore;



/** WEBPACK FOOTER **
 ** ./src/components/Stores/SessionStore.js
 **/